import { FC } from 'react';
import { useParams } from 'react-router-dom';
import { TeamMemberAnnualLeaveCard } from './TeamMemberAnnualLeaveCard';

export const annualLeaveSectionId = 'annual-leave-section';

export const TeamMemberAnnualLeaveSection: FC = () => {
  const { userId } = useParams<'userId'>();

  return <section id={annualLeaveSectionId}>{userId && <TeamMemberAnnualLeaveCard employeeId={userId} />}</section>;
};
